import { render, staticRenderFns } from "./PanelEmbeds.vue?vue&type=template&id=5c0a580e&scoped=true&"
import script from "./PanelEmbeds.vue?vue&type=script&lang=js&"
export * from "./PanelEmbeds.vue?vue&type=script&lang=js&"
import style0 from "./PanelEmbeds.vue?vue&type=style&index=0&id=5c0a580e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0a580e",
  null
  
)

export default component.exports